import { render, staticRenderFns } from "./touristSatisfaction.vue?vue&type=template&id=2bb64718&scoped=true&"
import script from "./touristSatisfaction.vue?vue&type=script&lang=js&"
export * from "./touristSatisfaction.vue?vue&type=script&lang=js&"
import style0 from "./touristSatisfaction.vue?vue&type=style&index=0&id=2bb64718&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb64718",
  null
  
)

export default component.exports